import React, { useCallback,useEffect, useState } from 'react';
import classNames from 'classnames';

import classes from './MoreItemsDropdown.module.css';

const MoreItemsDropdown = ({ items, id = 'more-items-dropdown', onClick }) => {
  const [show, setShow] = useState(false);

  // Click away effect
  useEffect(() => {
    window.addEventListener('click', handleClick);
    function handleClick(event) {
      if (!document.getElementById(id).contains(event.target)) {
        setShow(false);
      }
    }
    return () => window.removeEventListener('click', handleClick);
  }, [show]);

  const handleOnClick = useCallback(
    (e, item) => {
      if (onClick) {
        return onClick(e, item);
      }
      return null;
    },
    [onClick]
  );

  return (
    <div
      id={id}
      className={classNames(
        classes['more-items-dropdown-container'],
        `${items.some((i) => i.isCurrentPage) ? classes.active : ''} ${show ? classes.open : ''}`
      )}
      onClick={() => setShow(!show)}
    >
      <span className={classNames(classes['dropdown-toggler'], `${show ? classes.open : ''}`)}>
        More <i className="submenuArrowIcon" aria-hidden="true"></i>
      </span>
      <div className={classNames(show ? classes.arrows : 'd-none')}>{''}</div>
      <ul
        className={classNames(classes['more-items-dropdown-list'], `${show ? classes.open : ''}`)}
      >
        {items.map((item) => (
          <li
            key={item.title}
            className={classes['more-items-dropdown-list-item']}
            onClick={(e) => handleOnClick(e, item)}
          >
            {item.isCurrentPage ? item.title : <a href={item.link}>{item.title}</a>}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default MoreItemsDropdown;
